import { defaultReviewFilterValues } from '../../../config/defaultStatisticsFilters';
import { Statistic } from '../../../workers/sortAndFilter/statistics/statistics.worker';
import { Command, ReviewData } from '../interfaces';
import { FilterCommand } from './FilterCommand';

/**
 * Filter based on the review. I.e treatment review is >= 4.5.
 * @param data a treatment
 * @returns Statistic
 */
export const reviewFilterStatistics = <T extends ReviewData>(data: T[], keys: number[]) =>
    data.filter((element) => keys.some((key) => key <= element.selectedReview.averageRating));

export class ReviewFilterStatisticsCommand extends FilterCommand implements Command {
    isAndFilter() {
        return undefined;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    execute(data: ReviewData[], keys: number[]) {
        let items = null;
        const statistics: Statistic[] = [];

        defaultReviewFilterValues.forEach((value) => {
            items = reviewFilterStatistics(data, [value]);
            const statistic = {
                type: this.type,
                key: value,
                statistics: {
                    value: items.length,
                },
            };
            statistics.push(statistic);
        });

        return statistics;
    }
}
